<div [class.disabled]="disabled" (mouseleave)="onRatingBlur()" class="wrapper">
  <div [class.rated]="userRating" class="wrapper__stars">
    <rt-icon
      *ngFor="let rating of ratings; trackBy: trackByValue"
      (mouseenter)="onRatingHover(rating)"
      (click)="onRatingClick(rating)"
      [name]="iconName(rating)"
      size="medium"
    >
    </rt-icon>
  </div>

  <div *ngIf="!hideRating" class="wrapper__text">
    <rt-truncate>
      <span *ngIf="showLabel()" class="label">
        {{ label }}
      </span>
    </rt-truncate>
    <span *ngIf="rated" class="label"> {{ 'rtu.common.rating.rated' | translate }}&nbsp; </span>
    <rt-heading *ngIf="showRating()" class="large-x rating">
      {{ roundedRating }}
    </rt-heading>
  </div>
</div>

<div *ngIf="userRating" class="meta">
  {{ 'rtu.candidate.your_rating' | translate }} <b>{{ userRating }} / 5</b>
</div>
